<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header"><i class="fa-solid fa-house-chimney-user"></i> Vendégházak <small></small></h1>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<panel title="Vendégházak">
					<Loading v-if="!guesthouses" title="Vendégházak betöltése"></Loading>
					<NoRecords v-else-if="guesthouses.length == 0" main_icon="fa-solid fa-house-chimney-user" value="false" title="Nincsenek vendégházak"></NoRecords>
					<div v-else>
						<div class="text-end">
							<help helpId="guesthouse_table_help" title="Venbdégház lista" text="a vendégházakat szűrheti valamint a szerkesztés gombbal megnézheti a részletes nézetüket"></help>
						</div>
						<vue-good-table
							:columns="columns" 
							:rows="guesthouses" 
							:lineNumbers="true"
							:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
							:pagination-options="{
								enabled: true, 
								position: 'bottom',
								firstLabel : 'Első Lap',
								lastLabel : 'Utolsó Lap',
								nextLabel: 'következő',
								prevLabel: 'előző',
								rowsPerPageLabel: 'Sor oldalanként',
								ofLabel: '/',
								allLabel: 'Összes',
								infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`, 
							}"
						>
							<template slot="table-row" slot-scope="props">
								<span v-if="props.column.field == 'actions'">
									<router-link :to="'/guesthouses/'+props.row.id+'/edit'" class="btn btn-warning btn-sm mx-1" title="szerkesztés"><i class="fa fa-edit"></i></router-link>
								</span>
								<span v-else-if="props.column.field == 'apartment'">
									<div class="text-center">
										<i v-if="props.row.apartment == 1" class="fa-solid fa-circle-check text-green fa-2x"></i>
										<i v-else class="fa-solid fa-circle-xmark text-red fa-2x"></i>
									</div>
								</span>
								<span v-else>
									{{props.formattedRow[props.column.field]}}
								</span>
							</template>
						</vue-good-table>
					</div>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
	import Guesthouse from '../../apis/Guesthouse';
	export default {
		name:'Guesthouses',
		data() {
			return {
				guesthouses:false,
				guesthouse:{},
				loading: false,
				errors:[],
				columns: [
					{
						label: 'Név',
						field: 'name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés a nevek közt',
						}
					},
					{
						label: 'Város',
						field: 'city',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés a nevek közt',
						}
					},
					{
						label: 'Cím',
						field: 'address',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés a nevek közt',
						}
					},
					{
						label: 'Apartman',
						field: 'apartment',
						filterOptions : {
							filterDropdownItems:[
								{ value: 0, text: "nem"},
								{ value: 1, text: "igen"},
							],
							placeholder: 'Összes',
							enabled:true,
						}
					},
					{
						label: 'Műveletek',
						field: 'actions',
						width: '15%',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
			}
		},
		created() {
			Guesthouse.index()
			.then(response => {
				this.guesthouses = response.data;
			}).catch(() => {
				this.guesthouses = []
			})
		},
		methods: {
			
		}
	};
</script>